import { applyMiddleware, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';
import { extractUGC } from '../utils/ugc/extractUGC';
import reducer from '../reducers';

const createUGCMap = (props) => ({
    original: extractUGC(props),
    translated: undefined
});

const createGigStore = (props) => {
    const ugcMap = createUGCMap(props);
    const { packages, studio, general, workProcess, tags } = props;
    const reducers = reducer({ packages, studio, general, ugcMap, workProcess, tags });

    return createStore(reducers, applyMiddleware(ReduxThunk));
};

export default createGigStore;
